import { useContext } from 'react'

import { Snackbar, SnackbarContent } from '@material-ui/core'
import { reducerContext } from '../../contextApi\'s/contextApi\'s'


const SnackbarAlert = () => {

    const { state, dispatch } = useContext(reducerContext)
    const { showErr, mySnack, errorMsg } = state

    const handleCloseContactModal = () => {
        dispatch({
            type: 'SET_SHOW_ERROR',
            payload: false
        })
    }

    return (
        <div>
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
                open={showErr}
                autoHideDuration={2000}
                onClose={handleCloseContactModal}
            >
                <SnackbarContent
                    style={mySnack}
                    message={
                        <span style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#333333",
                            fontSize: "12px",
                            fontFamily: "cardiuma-regular"
                        }}>
                            {errorMsg}
                        </span>
                    }
                />
            </Snackbar>
        </div>
    )
}

export default SnackbarAlert